module.exports = __webpack_public_path__ + "static/media/button_icon_add_friend.d880ed17.svg";